import React from "react";

const tanmay_karad = () => {
  return (
    <div>
      <h1>Tanmay Karad</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students from Circuit Branches with a CGPA of 7.0 and above were
        eligible for the OA of Embedded Systems Role. Note: CS students were
        only eligible for the embedded systems role (there were other roles like
        analog and digital). Based on the OA score, a total of 7 students were
        shortlisted for the interview process of embedded systems role.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The OA test was scheduled on Saturday (11th Oct), the shortlist for
        interviews was announced on Tuesday (14th Oct), the Interview process
        took place the next day, ie. Wednesday (15th Oct), and the results were
        announced the same evening.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The OA test consisted of 3 sections (90 mins):{" "}
      </p>

      <ol>
        <li>
          Aptitude Section - 20 questions - 30 mins
          <ol>
            <li>It consisted of mathematics and logic-based questions. </li>
            <li>The questions were a mix of MCQs and fill-in-the-blank. </li>
          </ol>
        </li>
        <li>
          Technical Section - 20 questions - 40 mins
          <ol>
            <li>
              It consisted of DSA and C programming language-based questions.{" "}
            </li>
            <li>
              There were also a few questions covering topics from MPT, DLD,
              etc.{" "}
            </li>
            <li>
              All the questions were in MCQ format, but included types like
              given a piece of code, choose the correct output,
              fill-in-the-blanks, find an error in the given code, straight-up
              theory/concept-based questions, etc.{" "}
            </li>
          </ol>
        </li>
        <li>
          Coding Section - 1 question - 20 mins
          <ol>
            <li>
              There was an easy-to-moderate difficulty level DSA question
              (somewhat based on the binary search concept).{" "}
            </li>
            <li>
              The question had a total of 12 test cases, with 2 visible ones and
              the rest hidden. (I managed to pass 9/12){" "}
            </li>
          </ol>
        </li>
        <li>
          Overall, the OA was of moderate level, but it had{" "}
          <strong>negative marking</strong>.
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />7 students were shortlisted after the Aptitude Round for the
        Embedded Systems Role.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced on Tuesday (14th Oct) in the afternoon,
        while the interviews were scheduled for Wednesday (15th Oct) morning, so
        we roughly had a day to prepare for the interview. I revised the major
        concepts of OS, and a few concepts from DLD, MPT, and CO, though already
        being prepared mattered more than the last-minute prep. I specifically
        revised the topic of bit manipulation, since it was mentioned by the
        company in the requirements section.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        Since the interviews were online (from the TnP cell via Webex), there
        was only 1 technical interview round conducted.{" "}
      </p>

      <ol>
        <li>
          The interview consisted of various questions based on DSA, OS, and the
          C Programming Language.{" "}
        </li>
        <li>
          Topics like demand paging and fragmentation were asked from OS.{" "}
        </li>
        <li>
          I was asked to write a simple ADT for BST in C, ie, the struct for BST
          node, insert node function, but with proper C language syntax, and
          also a continuous explanation while programming the same.{" "}
        </li>
        <li>
          There was a question on Bit-manipulation topic. The question: Swap the
          adjacent even and odd position bits of an 8-bit number, considering
          LSB is odd position (but in constant time), which I could tackle with
          some help from the interviewer.{" "}
        </li>
        <li>
          1 question was based on my DSA project, and 1 question was to
          determine the size of the given struct.
        </li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewers focused on OS, DSA, and the C programming language.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ol>
        <li>Striver sheet for DSA. </li>
        <li>Abhijit Sir’s lectures for OS, DSA. </li>
        <li>India Bix for aptitude questions.</li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice on platforms like Leetcode, and refer Striver’s DSA Sheet.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Since there was only 1 technical interview round, I was asked only 1
        question on my DSA Project, and no questions on other extra-curricular
        activities/clubs.
        <br />I did mention my hobbies in the introduction.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Work well on the fundamental concepts of OS, DSA topics (mainly
        bit-manipulation), and other topics related to embedded systems.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Don’t get disheartened by rejections and keep working hard throughout
        the process. I personally faced 2 rejections before successfully getting
        shortlisted here, so be consistent in your work, and keep striving until
        you get it.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:karadtk23.comp@coeptech.ac.in">karadtk23.comp@coeptech.ac.in</a>
      </p>
    </div>
  );
};

export default tanmay_karad;
